/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/9/18
 * Time: 09:38
 * Desc: 营销中心-秒杀活动
 */
import { parse } from 'querystring';
import { Component, Vue } from 'vue-property-decorator';
import type { ElTree } from 'element-ui/types/tree';
import moment from 'moment';
import SeckillOrderDetail from '@/views/components/seckillOrderDetail/seckillOrderDetail.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

import { appEnvConfig } from '@/configs/appConfigs';
import { noop, parseSec } from '@/util';
import GenerateLink from '@/views/components/generateLink';
import NewSelectSite from '@/views/components/newSelectSIte';

export enum activityState {
  NOT_STARTED = 1, // 未开始
  PREHEAT_PERIOD = 2, // 预热期
  SECKILL_PERIOD = 3, // 秒杀期
  FINISHED = 4, // 已结束
  DISMOUNT = 0, // 已下架
  ALL = 9, // 全部
}

@Component({
  components: {
    'seckill-order-detail': SeckillOrderDetail,
  },
  filters: {
    filterState(val) {
      if (val == 0) {
        return '已下架';
      } else if (val == 1) {
        return '未开始';
      } else if (val == 2) {
        return '预热期';
      } else if (val == 3) {
        return '秒杀中';
      } else if (val == 4) {
        return '已结束';
      }
    },
  },
})
export default class SeckillGroup extends Vue {
  public activteStateText = [
    { value: activityState.ALL, text: '全部' },
    { value: activityState.NOT_STARTED, text: '未开始' },
    { value: activityState.PREHEAT_PERIOD, text: '预热期' },
    { value: activityState.SECKILL_PERIOD, text: '秒杀中' },
    { value: activityState.FINISHED, text: '已结束' },
    { value: activityState.DISMOUNT, text: '已下架' },
  ];

  // 当前登录人的code
  public empCode = '';
  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 活动状态
   * @type {string}
   */
  public activityState = '';

  /**
   * 秒杀状态
   * @type {string}
   */
  public seckillState = '';

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中活动
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 秒杀列表
   * @type {Array<SeckillGroupList>}
   */
  public seckillList: Array<SeckillGroupList> = [];

  /**
   * 网点列表是否显示
   * @type {boolean}
   */
  public isSiteListShow = false;

  /**
   * 网点列表
   * @type {Array<siteList>}
   */
  public siteList: Array<SiteList> = [];

  /**
   * 当前秒杀名称
   * @type {string}
   */
  public curSeckillName = '';

  /**
   * 规格列表是否显示
   * @type {boolean}
   */
  public isScaleTableVisible = false;

  /**
   * 节点key
   * @type {Object}
   */
  public defaultProps: Object = {
    children: 'children',
    label: 'name',
  };

  /** *************网点销量的参数 start*****************/

  public skgId = null;
  public index = 0;
  public selectedList: Array<SeckillGroupList> = [];
  public scaleList: Array<ScaleList> = [];
  public isSocketReady = false;
  public orderSiteLoading = false;
  public isLastTree = false;
  public AssembleActSiteOrderCode = null;
  public findNodeList = [];
  public findNodeListSiteCode = [];
  public saleNumberKeywords = '';
  public saleNumberSiteList = [];
  public defaultExpandedKeys = [];
  public saleSitePage = 1;
  public saleSitePageSize = 10;
  public saleSiteTotalCount = 0;
  public saleSiteKeywords = '';

  public saleSiteList = [];

  public SaleSiteResultPage = 1;
  public SaleSiteResultPageSize = 10;
  public SaleSiteResultTotalCount = 0;

  public isOrderDetailVisible = false;
  public saleNumberLoading = false;

  // protected sendToService: any[] = [IPSService.PtProductListExport, IPSService.secKillOrderListExport, IPSService.secKillOrderListExport];

  public date = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;

  /** *************网点销量的参数 end*****************/

  /**
   * 设置节点选中状态
   * @param {string} val
   * @returns null
   */
  public setCurrentkey(val: string): void {
    this.$nextTick(() => {
      (this.$refs.elTree as ElTree<any, any>).setCurrentKey(val);
    });
  }

  public onSaleSiteSizeChange(val: number): void {
    this.saleSitePageSize = val;
    this.getSaleNumber();
  }

  onSaleSitePageChange(val) {
    this.saleSitePage = val;
    this.getSaleNumber();
  }

  public onSaleSiteResultSizeChange(val: number): void {
    this.SaleSiteResultPageSize = val;
    this.getSiteOrderList();
  }

  onSaleSiteResultPageChange(val) {
    this.SaleSiteResultPage = val;
    this.getSiteOrderList();
  }

  public onSaleSiteSearch() {
    this.getSiteOrderList();
  }

  handleCloseActiveTrack() {
    this.saleNumberKeywords = '';
    this.isScaleTableVisible = false;
  }

  public onActSiteOrderDetail(item): void {
    this.isLastTree=true
    this.closeSockets();
    this.createConnect(2);
    this.AssembleActSiteOrderCode = item.siteCode;
    this.getSiteOrderList();
  }

  public onSaleNumberSearch() {
    this.saleSitePage = 1;
    this.saleSitePageSize = 10;
    this.getSaleNumber();
  }

  public onLink(item) {
    GenerateLink.open({
      item,
      title: '生成秒杀链接',
      type: 'skillGroup',
      confirm: false,
      remarkList: ['注1：默认生成的链接为适用网点列表第一个网点的链接，可通过输入网点编号后进行更换；'],
    }).then(noop, noop);
  }

  /**
   * 点击节点
   * @param {string} data
   * @return null
   */

  /**
   * 导出
   * @param {number} index
   * @return null
   */
  public onExportList(index: number): void {
    this.index = index;
    this.$set(this.exportBtnInfo, index, {
      state: 1,
      url: '',
    });
    const exportsId = this.sendToIdList[index];
    let postParams = {};

    switch (index) {
      case 0:
        postParams = {
          sendToId: exportsId,
          activityState: this.activityState === '' ? 9 : Number.parseInt(this.activityState),
          keyword: this.keywords,
        };
        // IPSService.skillListExport({postParams});
        break;
      case 1:
        postParams = {
          sendToId: exportsId,
          exportType: index,
          siteCodes: this.findNodeListSiteCode.length ? this.findNodeListSiteCode : '1',
          skgId: this.skgId,
          keyword: this.saleNumberKeywords,
        };
        // IPSService.secKillOrderListExport({ postParams: postParams });
        break;
      case 2:
        postParams = {
          sendToId: exportsId,
          exportType: index,
          siteCode: this.AssembleActSiteOrderCode,
          skgId: this.skgId,
          keyword: this.saleSiteKeywords,
        };
        // IPSService.secKillOrderListExport({ postParams: postParams });
        break;
      default:
        break;
    }
  }

  public getSaleNumber() {
    const postParams = {
      skgId: this.skgId,
      keyword: this.saleNumberKeywords,
      page: this.saleSitePage,
      pageSize: this.saleSitePageSize,
      siteCodes: this.findNodeListSiteCode,
    };
    IPSService.secKillGroupSiteList({ postParams }).then((res) => {
      this.saleSiteTotalCount = res.count;
      this.saleNumberSiteList = res.list;
      this.saleNumberLoading = false;
    });
  }

  public sendToIdList = [];
  public getSiteOrderList() {
    const postParams = {
      skgId: this.skgId,
      siteCode: this.AssembleActSiteOrderCode,
      keyword: this.saleSiteKeywords,
      page: this.SaleSiteResultPage,
      pageSize: this.SaleSiteResultPageSize,
    };
    IPSService.secKillGroupOrderList({ postParams }).then((res) => {
      this.SaleSiteResultTotalCount = res.count;
      this.saleSiteList = res.list.map((i: any) => {
        i.orderTime = moment(i.orderTime * 1000).format('YYYY-MM-DD HH:mm:ss');
        i.payTime = moment(i.payTime * 1000).format('YYYY-MM-DD HH:mm:ss');
        return i;
      });
      this.orderSiteLoading = false;
    });
  }

  public findNodeSite(node) {
    if (Object.prototype.toString.call(node) === '[object Object]') {
      node = [node];
    }
    node.forEach((i) => {
      if (i.isSite) {
        this.findNodeList.push(i);
      }
      if (i.children && !i.isSite) {
        this.findNodeSite(i.children);
      }
    });
  }

  /**
   * 连接socket 生成消息体
   * @return null
   */
  public onSokectConnect(index): void {
    this.$socket.emit('login', this.sendToIdList[index]); // 发送信息给服务端
    this.sockets.subscribe('new_msg', (msg) => {
      // 接收服务端的信息
      // 接收服务端的信息
      if (msg) {
        const msgArr = msg.split('|');
        if (msgArr[0] === 'success') {
          const qiniuUrl = msgArr[3];
          this.$set(this.exportBtnInfo, index, {
            state: 2,
            url: qiniuUrl || `${Functions.ipsHostUrlApi()}/file/download?fileUrl=${msgArr[1]}`,
          });
        } else {
          this.$set(this.exportBtnInfo, index, {
            state: 0,
            url: '',
          });
        }
      }
    });
  }

  /**
   * 下载文件
   * @return null
   */
  public onDownLoadFile(index): void {
    location.href = this.exportBtnInfo[index].url;
    setTimeout(() => {
      this.$set(this.exportBtnInfo, index, {
        state: 0,
        url: '',
      });
    }, 2000);
  }

  /**
   * 创建连接
   * @return null
   * @param index
   */
  public createConnect(index = 0): void {
    setTimeout(() => {
      this.$socket.connect(); // socket建立连接
      this.onSokectConnect(index); // 打开socket
    }, 0);
    setTimeout(() => {
      this.isSocketReady = true;
    }, 1500);
  }

  public nodeList = [];
  /**
   * 当组建即将销毁时
   * @return null
   */
  public beforeDestroy() {
    this.closeSockets();
  }

  closeSockets() {
    this.sockets && this.sockets.unsubscribe && this.sockets.unsubscribe('new_msg'); // 取消订阅
    this.$socket && this.$socket.disconnect(); // 断开连接
  }

  // 弹窗的关闭
  activityResultDialogClose() {
    this.isLastTree=false
    this.scaleList = [];
    // 重连列表的socket
    this.closeSockets();
    this.createConnect(0);
  }

  getLineActiveText(row) {
    return this.activteStateText.find(i => i.value === row.activityState).text;
  }
  openSelectSiteDialog() {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.siteCodes,
      readonly: false,
    }).then((val: string[]) => {
      this.findNodeListSiteCode = val;
      this.getSaleNumber()
    }, noop);
  }
  public openSaleNumberDialog(item) {
    this.isScaleTableVisible = true;
    this.saleNumberLoading = true;
    this.siteCodes=item.siteCodes
    // 打开弹窗时，需关闭列表页的sockets,再重新打开
    this.closeSockets();
    this.createConnect(1);
    this.skgId = item.skgId;
    this.getSaleNumber()
    this.exportBtnInfo = [
      { state: 0, url: '' },
      { state: 0, url: '' },
      { state: 0, url: '' },
    ];
  }

  /**
   *  导出按钮的信息
   * @type {ItemObject}
   */
  public exportBtnInfo: Array<ItemObject> = [
    { state: 0, url: '' },
    { state: 0, url: '' }, // 网点导出按钮
    { state: 0, url: '' }, // 订单导出
  ];

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchSeckillList(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getSecKillList();
  }

  /**
   * 获取秒杀活动列表
   * @return null
   * @
   */
  public getSecKillList(): void {
    this.seckillList = [];
    const postParams = {
      page: this.page,
      pageSize: this.pageSize,
      keyword: this.keywords,
      status: this.activityState === '' ? 9 : Number.parseInt(this.activityState),
    };
    if (this.date && this.date.length) {
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('更新时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
        this.ipsGetList(postParams);
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  ipsGetList(postParams) {
    IPSService.secKillGroupList({ postParams }).then((res: ItemObject) => {
      this.totalCount = res.count;
      // 格式化数据
      if (res.list.length > 0) {
        res.list.forEach((item) => {
          item.secKillName = Functions.emptyVaribleHandler(item.secKillName);
          item.productName = Functions.emptyVaribleHandler(item.productName);
          item.productCode = Functions.emptyVaribleHandler(item.productCode);
          item.updatePerson = Functions.emptyVaribleHandler(item.updatePerson);
          item.actBeginTime = Functions.timeFormatSec(item.actBeginTime);
          item.actEndTime = Functions.timeFormatSec(item.actEndTime);
          item.addTime = Functions.timeFormatSec(item.addTime);
          item.beforeBeginTime = Functions.timeFormatSec(item.beforeBeginTime);
          item.updateTime = Functions.timeFormatSec(item.updateTime);
          // 计算秒杀价
          const sold = 0;
          const seckillStock = 0;
          item.proportion = item.seckillStock ? `${(item.sold * 100) / item.seckillStock}%` : '0%';
          item['seckillStock'] = seckillStock; // 秒杀库存
          item['sold'] = sold; // 已售库存
          const proportion2 = seckillStock > 0 ? (sold * 100) / seckillStock : 0;
          item['proportion'] = proportion2 > 0 ? `${proportion2.toFixed(2)}%` : '0%';
        });
      }
      this.seckillList = res.list;
    });
  }

  /**
   * 活动状态变更
   * @param {string} val
   * @return null
   */
  public onActivityStateChange(val: string): void {
    this.activityState = val;
    this.page = 1;
    this.pageSize = 10;
    this.getSecKillList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getSecKillList();
  }

  /**
   * 页码变更
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getSecKillList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
    this.selectedList = val;
  }

  /**
   * 改变秒杀活动的状态(单个)
   * @param {SeckillList} item
   */
  public onChangeSeckillState(item: SeckillGroupList): void {
    this.$confirm(`确认${item.state === 0 ? '上架' : '下架'}？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      const postParams = {
        skgIds: [item.skgId],
        state: item.state === 0 ? 1 : 0,
      };
      IPSService.secKillGroupStateEdit({ postParams }).then((res) => {
        if (res) {
          this.$message.success('更新成功');
          this.getSecKillList();
        } else {
          this.$message.warning('更新失败');
        }
      });
    });
  }

  /**
   * 改变秒杀活动的状态(批量)
   * @param {number} state
   * @return null
   */
  public onChangeSeckillStateMult(state: number): void {
    const tempStateList = [];
    this.selectedList.forEach((item) => {
      tempStateList.push(item.skgId);
    });
    const postParams = {
      skgIds: tempStateList,
      state,
    };

    this.$confirm(`确认批量${state === 1 ? '上架' : '下架'}？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      IPSService.secKillGroupStateEdit({ postParams }).then((res) => {
        if (res) {
          this.$message.success('更新成功');
          this.getSecKillList();
        } else {
          this.$message.warning('更新失败');
        }
      });
    });
  }

  /**
   * 删除秒杀活动
   * @return null
   */
  public onDeleteSeckill(item: SeckillGroupList): void {
    const postParams = {
      skgId: item.skgId,
    };
    this.$confirm('确认删除？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      IPSService.secKillGroupDel({ postParams }).then((res) => {
        if (res) {
          this.$message.success('删除成功');
          this.page = 1;
          this.pageSize = 10;
          this.getSecKillList();
        } else {
          this.$message.warning('删除失败');
        }
      });
    });
  }
siteCodes=[]
  /**
   * 网点列表显示
   * @return null
   */
	 public onSiteListShow(item: ItemObject): void {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: item.siteCodes,
      readonly: true,
    }).then(noop, noop);
  }

  /**
   * 订单明细列表隐藏
   * @return null
   */
  public onOrderDetailListHide(): void {
    this.isOrderDetailVisible = false;
  }

  /**
   * 去往秒杀活动编辑页面
   * @return null
   */
  public onGoToSeckillEditPage(item: SeckillGroupList): void {
    if (this.selectedList.length&&!item) {
      this.$confirm(`您即将复制“${this.selectedList[0].skgName}”秒杀组活动，点击“确定”将进入副本进行活动编辑`)
        .then((res) => {
          if (res === 'confirm') {
            this.$router.push({ path: `/seckillGroupEdit/${this.selectedList[0].skgId}`, query: { empCode: this.selectedList[0].updatePerson, isCopy: '1' } });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.$router.push({ path: `/seckillGroupEdit/${item.skgId}`, query: { empCode: item.updatePerson } });
    }
  }

  /**
   * 去往新建秒杀活动页面
   * @return null
   */
  public onGoToSeckillAddPage(): void {
    this.$router.push('/seckillGroupEdit/0');
  }

  public dateChange() {
    this.page = 1;
    this.getSecKillList();
  }
  /* 周期 */

  /**
   * 当组件创建时
   */
  public created() {
    this.sendToIdList = [`${appEnvConfig.NODE_ENV}secKillGROUPList${this.$store.state.empCode}`, `${appEnvConfig.NODE_ENV}secKillGROUP${this.$store.state.empCode}`, `${appEnvConfig.NODE_ENV}secKillGROUPDetail${this.$store.state.empCode}`];
    this.defaultStart = parseSec(3);
    this.defaultEnd = parseSec(4);
    this.date = [this.defaultStart, this.defaultEnd];
    // 因为有三个下载，所以每次切换时，需重新连接socket
    this.closeSockets();
    this.createConnect();
    this.getSecKillList(); // 获取秒杀活动列表
    this.empCode = localStorage.getItem('empCode') || '';
  }
}
